import unwrapModel from './unwrap-model'

import Backbone from 'backbone'
import $ from 'jquery'
import EditForm from 'scoreboard/components/edit/edit-form'
import DisplayHeader from 'scoreboard/components/display-header'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import template from 'scoreboard/components/scroll-container.hbs'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import conductor from 'scoreboard/components/conductor'
import { triggerAddOrEdit } from 'scoreboard/components/domain-object-events'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import { isV6 } from 'scoreboard/components/version'

var FolderForm = Backbone.View.extend({

	// this.model is a Backbone.Model representing a folder
	// this.options.tabs is a Handlebars template for rendering the tabs

	className: 'folder-form table-hack display-layout',

	events: {
		'click .cancel': 'cancel'
	},

	/*
	* @param {Object} [options.validator] one or more validators to be added to
	* the EditForm label field validators
	*/
	initialize: function(options) {
		this.options = options || {}
		this.editForm = new EditForm({
			model: this.model,
			validator: this.options.validator,
			disableMoveButton: this.options.disableMoveButton,
			disableCopyButton: this.options.disableCopyButton
		})
		let {label} = unwrapModel(this.model)

		// #56366
		// Ensure we do not overwrite default, or adjusted, labels when the view
		// using the folder form has not been saved
		if (this.model.isNew() && !label) {
			this.model.set('label', i18n.get('common.newFolder'))
		}

		this.formView = new FormView({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this),
			// Allow clean submission since we populate a placeholder label
			allowCleanSubmission: () => this.model.isNew(),
		})
		this.formView.on('change', this._change.bind(this))
		// #55529 the toggleCancel option on the FormView disables the cancel
		// button which in turn prevents events from being triggered on it, so
		// we have to manually listen to the cancel event from the FormView
		this.formView.on('cancel', () => this.cancel())
	},

	_change: function() {
		// potentially update the "New Folder" placeholder in the tree
		this.trigger('change', this._getChangeObject())
	},

	/**
	 * Returns the object passed along with the change event
	 */
	_getChangeObject: function () {
		return _.extend({type: 'folder'}, formHelper.readFromDom(this.el))
	},

	render: function({ instadone } = {}) {
		var tabContext = {
			id: this.model.id || this.model.get('parentId') || this.model.get('relativeId'),
			section: this.model.section,
			overviewTabCode: this.options.overviewTabCode ?? this.overviewTabCode,
			hideInfo: true,
			hideAlerts: true
		}
		// #57441 in v6 the heading is used as a placeholder for the label field
		// so the heading should be "New Folder" instead of "Create Folder"
		let headingMsgCode = 'common.create2'
		if (isV6()) {
			headingMsgCode = 'common.new2'
		}
		var heading = this.model.isNew() ?
			i18n.get(headingMsgCode, 'bookmarks.folder') :
			this.model.get('label')
		let tabs = this.options.tabs ?? this.tabs
		this.header = new DisplayHeader({
			heading: heading,
			model: this.model,
			subsection: 'edit',
			// TODO: Remove when V5 is no longer supported
			// Only remove the isV6() check.
			tabs: this.model.isNew() && isV6() ? '' : tabs?.(tabContext)
		})

		this.$el.empty().append(this.header.render().el, template())
			.addClass(this.model.section)
		var gridCell = $('<div class="grid-w-12"></div>').append(this.editForm.render().el)
		this.$('.scroll-container').append(gridCell)
		this.formView.start({
			isNew: this.model.isNew(),
			instadone,
			primaryButtonEl: this.$('.save')
		})

		// This folder is a part of a template
		if (this.model.get('templateId')) {
			this.editForm.$el.addClass('is-folder')
			this.$('.grid-w-12').prepend(`<div class="banner">${i18n.get('dashboards.cannotEditCopyFolder')}</div>`)
		}

		this.secure()

		// Pre-select the label field so users can start typing right away
		this.$('[name=label]').select()

		if (isV6()) {
			this.labelField = new MarkedField({
				el: this.$('[name=label]'),
				validator: requiredValidator
			}).render()
		}

		return this
	},

	secure: function() {
		// #22894 we didn't implement copying folders in the files section yet
		if (this.model.section === 'files') {
			this.$('.copy').remove()
		}
	},

	submit: function(e) {
		e && e.preventDefault()
		// record this now, because it will always be false inside the success callback
		var isNew = this.model.isNew()
		return this.model.save(this.getSubmitData(), {
			patch: true,
			success: function(model, response) {
				if (!model.get('id') && response.id) {
					// #37259 Set the new id if it's not already on the model
					model.set('id', response.id)
				}
				this.render({ instadone: true }) // #8449 we know the ID for the overview tab now
				this.trigger('save', model)
				var action = isNew ? 'add' : 'edit'
				this.$('.save').data('view').done()
				triggerAddOrEdit(action, model)
			}.bind(this)
		})
	},

	getSubmitData: function() {
		return { label: this.$('[name=label]').val() }
	},

	cancel: function() {
		if (this.model.isNew()) {
			if (conductor.id()) {
				conductor.edit()
			} else {
				var url = 'organizations/' + this.model.get('organizationId') + '/' + this.model.section
				conductor.navigate(url, { trigger: true })
			}
		} else {
			this.editForm.labelField.clearError()
			this.editForm.render()
			this.formView.start()
		}
	},

	remove: function() {
		Backbone.View.prototype.render.apply(this, this.arguments)
		_.invokeMap([this.header, this.editForm, this.formView], 'remove')
	}

})

export default FolderForm

FolderForm.__filename__ = 'components/folder-form.js'
